import { useQuery } from "@apollo/client";

import { AzureDevOpsRepoIntegration, Maybe } from "types/generated";

import { CHECK_AZURE_DEVOPS_HAS_DEFAULT_INTEGRATION } from "./gql";

const useCheckAzureDevOpsHasDefaultIntegration = (skip: boolean) => {
  const { data, loading } = useQuery<{
    checkAzureDevOpsHasDefaultIntegration: Maybe<Pick<AzureDevOpsRepoIntegration, "id">>;
  }>(CHECK_AZURE_DEVOPS_HAS_DEFAULT_INTEGRATION, {
    fetchPolicy: "no-cache",
    skip,
  });

  return {
    hasDefaultIntegration: typeof data?.checkAzureDevOpsHasDefaultIntegration?.id !== "undefined",
    loading,
  };
};

export default useCheckAzureDevOpsHasDefaultIntegration;
